export enum LangEnum {
  en = 'en-US',
  nb = 'nb-NO',
  pl = 'pl-PL',
  fi = 'fi-FI',
  sv = 'sv-SE',
  da = 'da-DK',
  de = 'de-DE',
  fr = 'fr-FR',
  pt = 'pt-PT',
  es = 'es-ES',
}

export const LOCALE_COOKIE_KEY = 'volve_locale';

export const API_URL = import.meta.env.VITE_API_URL;
export const PROXY_API_URL = import.meta.env.VITE_PROXY_API_URL;
export const AI_API_URL = import.meta.env.VITE_AI_API_URL;
export const MAX_FILE_SIZE_IN_MEGABYTES = import.meta.env.VITE_MAX_FILE_SIZE_MEGABYTES
  ? +import.meta.env.VITE_MAX_FILE_SIZE_MEGABYTES
  : 200;

export const ALLOWED_FILE_TYPES = ['pdf', 'docx', 'xlsx', 'csv'];

export const SHAREPOINT_CODE_VERIFIER_SESSION_KEY = 'sharepointCodeVerifier';
export const SHAREPOINT_STATE_PARAM = 'sharepointStateParam';
// Stores the page the user started the SharePoint login from so we can navigate back after callback
export const SHAREPOINT_POST_LOGIN_RETURN_URL = 'sharepointPostLoginReturnUrl';
export const SHAREPOINT_POST_LOGOUT_RETURN_URL = 'sharepointPostLogoutReturnUrl';

export const localStorageKeys = {
  SHAREPOINT_FOLDER_WARNING_DISMISSED: 'sharepointFolderWarningDismissed',
};

export const queryKeys = {
  USERS: 'users',
  IS_USER_ON_BOARD: 'isUserOnBoard',
  USER_ORGANIZATIONS: 'userOrganizations',
  TENDER_PACKAGES: 'tenderPackages',
  TENDER_PACKAGE_DETAILS: 'tenderPackageDetails',
  TENDER_PACKAGE_TOPIC_STATEMENTS: 'tenderPackageTopicStatements',
  TENDER_PACKAGE_SUMMARIZATION_STATUSES: 'tenderPackageSummarizationStatuses',
  TENDER_PACKAGE_TOPIC_STATUS: 'tenderPackageTopicStatus',
  BIDS: 'bids',
  BID_DETAILS: 'bidDetails',
  BIDS_SUMMARIZATION: 'bidsSummarization',
  BID_COMPARISON: 'bidComparison',
  BID_COMPARISON_ARE_DOCS_INDEXED: 'bidsComparisonAreDocsIndexed',
  CHAT_SESSION: 'chatSession',
  REPORT_EXPORT_STATUS: 'reportExportStatus',
  CONTRACTS: 'contracts',
  CONTRACT_DETAILS: 'contractDetails',
  ENTITY_DOCUMENTS: 'entityDocuments',
  DEVIATIONS: 'deviations',
  DEVIATIONS_STATUS: 'deviationsStatus',
  ADMIN_ORGANIZATIONS: 'adminOrganizations',
  ORGANIZATION_USERS: 'organizationUsers',
  ORGANIZATION_TEMPLATES: 'organizationTemplates',
  ORGANIZATION_EXTRACTIONS: 'organizationExtractions',
  SUPPLEMENTS: 'supplements',
  SUPPLEMENT_DETAILS: 'supplementDetails',
  SUPPLEMENT_OVERVIEW: 'supplementOverview',
  SUPPLEMENT_DOCUMENTS: 'supplementDocuments',
  INCONSISTENCY: 'inconsistency',
  INCONSISTENCY_STATUS: 'inconsistencyStatus',
  PROJECTS: 'projects',
  PROJECTS_ACCESS_USERS: 'projectsAccessUsers',
  PROJECTS_ACCESS_UNASSIGNED_USERS: 'projectsAccessUnassignedUsers',
  PROJECTS_ACCESS_ORG_USERS: 'projectsAccessOrgUsers',
  EVALUATIONS: 'evaluations',
  EVALUATION_DETAILS: 'evaluationDetails',
  PROJECT_META: 'projectMeta',
  PROJECT_DETAILS: 'projectDetails',
  PROJECT_DOCUMENT: 'projectDocument',
  ORGANIZATION_STATISTICS: 'organizationStatistics',
  PROJECT_INSIGHTS: 'projectInsights',

  STRENGTHS_WEAKNESSES: 'strengthsWeaknesses',
  AMBIGUITIES: 'ambiguities',
  AMBIGUITY: 'ambiguity',
  AMBIGUITY_STATUS: 'ambiguityStatus',
  AMBIGUITY_STATEMENTS: 'ambiguityStatements',
  BID_DRAFT: 'bidDraft',
  BID_DRAFT_STATUS: 'bidDraftStatus',
  GET_SUMMARIZATION: 'getSummarization',
  GET_EVALUATION_INSIGHTS: 'getEvaluationInsights',
  RESOURCE_DETAILS: 'resourceDetails',
  CONTRACT_DEVIATIONS_STANDARD: 'contractDeviationsStandard',

  EVALUATION_SUMMARIZATION_STATUS: 'evaluationSummarizationStatus',
  SUMMARIZATION_AVERAGE_PROGRESS: 'summarizationAverageProgress',
  TOPIC_STATEMENTS: 'topicStatements',
  CUSTOM_TOPIC_SUMMARIZATION_STATUS: 'customTopicSummarizationStatus',
  CUSTOM_TOPIC_STATEMENTS: 'customTopicStatements',

  EXTRACTION_LIST_TEMPLATES: 'extractionListTemplates',
  EXTRACTION_LIST_TEMPLATE: 'extractionListTemplate',
  EXTRACTION_TEMPLATES: 'extractionTemplates',
  EXTRACTION_TEMPLATE: 'extractionTemplate',
  EXTRACTIONS_OVERVIEW_V2: 'extractionsOverviewV2',
  EXTRACTION_DEFINITIONS_V2: 'extractionDefinitionsV2',

  FOLDER_TREE: 'folderTree',

  BID_QUALITY_DETAILS: 'bidQualityDetails',
  BID_QUALITY_TOTAL_SCORE: 'bidQualityTotalScore',
  BID_QUALITY_STATUS: 'bidQualityStatus',
  BID_QUALITY_STATEMENT: 'bidQualityStatement',
  BID_QUALITY_DOCUMENT: 'bidQualityDocument',
  BID_QUALITY_SECTION: 'bidQualitySection',
  BID_QUALITY_CATEGORIES: 'bidQualityCategories',
  BID_METHODOLOGY_SUMMARY: 'bidMethodologySummary',

  BID_CV_DETAILS: 'bidCvDetails',

  ORGANIZATION_KNOWLEDGE_BASES: 'organizationKnowledgeBases',
  KNOWLEDGE_BASE_DOCUMENTS: 'knowledgeBaseDocuments',
  TENDER_FEEDBACKS: 'tenderFeedbacks',
  TENDER_FEEDBACK_OVERVIEW: 'tenderFeedbackOverview',
  ORGANIZATION_TENDER_FEEDBACKS: 'organizationTenderFeedbacks',
  TENDER_FEEDBACK_DOCUMENTS: 'tenderFeedbackDocuments',

  EARLY_PHASE_ASSESSMENTS_DETAILS: 'earlyPhaseAssessmentsDetails',
  DEPENDENCIES: 'dependencies',
  DEPENDENCY: 'dependency',
  DEPENDENCIES_STATUS: 'dependenciesStatus',
  DEPENDENCIES_DOCUMENTS: 'dependenciesDocuments',
  EPA_ANNOTATION_DOCUMENTS: 'epaAnnotationDocuments',
  EPA_ANNOTATIONS: 'epaAnnotations',
  EPA_ANNOTATION_DOCUMENT: 'epaAnnotationDocument',
  EPA_ANNOTATIONS_TOTAL_COUNT: 'epaAnnotationsTotalCount',
  SEGMENT_INCONSISTENCIES: 'segmentInconsistencies',
  SEGMENT_INCONSISTENCIES_CATEGORIES: 'segmentInconsistenciesCategories',

  COMPANIES: 'companies',
  LEARNINGS: 'learnings',

  TENDER_FEEDBACK_POSITIVES_NEGATIVES: 'tenderFeedbackPositivesNegatives',
  TENDER_FEEDBACK_POSITIVES_NEGATIVES_STATUS: 'tenderFeedbackPositivesNegativesStatus',

  CHANGE_ASSESSMENT_LIST: 'changeAssessmentList',
  CHANGE_ASSESSMENT: 'changeAssessment',
  CHANGE_ASSESSMENT_DOCS_LIST: 'changeAssessmentDocsList',
  SUPPLEMENT_INDEXED_DOCUMENTS_STATUS: 'supplementIndexedDocumentsStatus',
  INDEXING_STATUS: 'indexingStatus',
  CHAT_HISTORY: 'chatHistory',

  CLAUSE_SCANNER_CATEGORIES: 'clauseScannerCategories',
  CLAUSE_SCANNER_SUBCATEGORY: 'clauseScannerSubcategory',
  CLAUSE_SCANNER_STATUS: 'contractClauseScannerStatus',
  CLAUSE_SCANNER_CLAUSE: 'clauseScannerClause',

  WORK_PACKAGES_LIST: 'workPackagesList',
  WORK_PACKAGES_CONTENT: 'workPackagesContent',
  WORK_PACKAGE_STATUS: 'workPackageStatus',
  AVAILABLE_PROCESSES: 'availableProcesses',
  PROCESSES: 'processes',
  PROCESS_DETAILS: 'processDetails',

  WP_SHEETS: 'wpSheets',
  WP_SHEET: 'wpSheet',
  WP_PACKS: 'wpPacks',
  WP_SHEET_LAYOUT: 'wpSheetLayout',
  WP_CHECKLIST_TEMPLATES: 'wpChecklistTemplates',
  WP_CHECKLIST_TEMPLATE: 'wpChecklistTemplate',

  SHAREPOINT_CONNECTION_STATUS: 'sharepointConnectionStatus',
  SHAREPOINT_SITES: 'sharepointSites',
  SHAREPOINT_DRIVES: 'sharepointDrives',
  SHAREPOINT_ITEMS: 'sharepointItems',
  SHAREPOINT_SYNC_PREVIEW: 'sharepointSyncPreview',
  DOCUMENT_VERSIONS: 'documentVersions',
  EVALUATION_LATEST_VERSION: 'evaluationLatestVersion',
  EVALUATION_VERSIONS: 'evaluationVersions',
};

export const mutationKeys = {
  ANALYSE_RFP_DOCUMENTS: 'analyseRfpDocuments',
  ANALYSE_BID_DOCUMENTS: 'analyseBidDocuments',
  ANALYSE_CONTRACT_DOCUMENTS: 'analyseContractDocuments',
  ANALYSE_SUPPLEMENT_DOCUMENTS: 'analyseOtherSupplementDocuments',
  ANALYSE_EARLY_PHASE_ASSESSMENT_DOCUMENTS: 'analyseEarlyPhaseAssessmentDocuments',
  REFRESH_RFP_TOPIC_BY_KEY: 'refreshRfpTopicByKey',
  REFRESH_BID_TOPIC_BY_KEY: 'refreshBidTopicByKey',
  REFRESH_CONTRACT_TOPIC_BY_KEY: 'refreshContractTopicByKey',
  EXPORT_REPORT: 'exportReport',
};

export enum ReportType {
  BIDS,
  BID_COMPARISON,
  RFP,
  CONTRACT,
  EARLY_PHASE_ASSESSMENT,
}

export enum ExtractionsReportType {
  RFP,
  CONTRACT,
}

/**
 * Labels used for generated file names of reports.
 */
enum ReportTypeLabels {
  BIDS = 'Bid',
  BID_COMPARISON = 'Bid_Comparison',
  RFP = 'Rfp',
  CONTRACT = 'Contract',
  EARLY_PHASE_ASSESSMENT = 'Early_Phase_Assessment',
}
export const ReportTypeLabelsMap: Record<ReportType, string> = {
  [ReportType.BIDS]: ReportTypeLabels.BIDS,
  [ReportType.BID_COMPARISON]: ReportTypeLabels.BID_COMPARISON,
  [ReportType.RFP]: ReportTypeLabels.RFP,
  [ReportType.CONTRACT]: ReportTypeLabels.CONTRACT,
  [ReportType.EARLY_PHASE_ASSESSMENT]: ReportTypeLabels.EARLY_PHASE_ASSESSMENT,
};

export enum DocumentAnalysisApiStatus {
  PREPARING_DATA_FAILED = 41,
  SUMMARIZATION_FAILED = 40,
  SUMMARIZATION_DONE = 30,
  PREPARING_SUMMARIZATION = 20,
  PREPARING_DATA = 10,
  DRAFT = 0,
}

export enum DocumentAnalysisApiStatusKeys {
  PREPARING_DATA_FAILED = 'PreparingDataFailed',
  SUMMARIZATION_DONE = 'SummarizationDone',
  PREPARING_SUMMARIZATION = 'PreparingSummarization',
  SUMMARIZATION_FAILED = 'SummarizationFailed',
  DATA_PREPARED = 'DataPrepared',
  PREPARING_DATA = 'PreparingData',
  DRAFT = 'Draft',
}

export enum SummarizationTypes {
  RFP_SUMMARY,
  BID_SUMMARY,
  BID_COMPARISON,
  CONTRACT,
}

/** Local definition for request separations, just in case the api interface changes */
export enum SummarizationNamespaces {
  BID = 'bid',
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
  SUPPLEMENT = 'supplement',
  TENDER_FEEDBACK = 'tenderFeedback',
  EARLY_PHASE_ASSESSMENT = 'earlyPhaseAssessment',
}

export enum AnalysisTypes {
  BID_DRAFTING = 'BID_DRAFTING',
  INCONSISTENCIES = 'inconsistencies',
  SEGMENT_INCONSISTENCIES = 'segmentInconsistencies',
  DEVIATIONS = 'deviations',
  AMBIGUITIES = 'ambiguities',
  BID_QUALITY = 'bidQuality',
  CV_ASSESSMENT = 'cvAssessment',
  DEPENDENCIES = 'dependencies',
  TENDER_FEEDBACK_POSITIVES_NEGATIVES = 'tenderFeedbackPositivesNegatives',
  CLAUSE_SCANNER = 'clauseScanner',
  WORK_PACKAGES = 'workPackages',
}

export enum StandardDeviationsTypes {
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
}

export enum DeviationsStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export enum DocumentTypes {
  BID = 'bid',
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
  SUPPLEMENT = 'supplement',
  EARLY_PHASE_ASSESSMENT = 'earlyPhaseAssessment',
}

export enum ProxyDocumentTypes {
  BID = 'bid',
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
  SUPPLEMENT = 'supplement',
  EARLY_PHASE_ASSESSMENT = 'earlyPhaseAssessment',
  INTERNAL_KNOWLEDGE_BASE = 'internalKnowledgeBase',
}

export enum AnalysisDocumentTypes {
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
  BID = 'bid',
  EARLY_PHASE_ASSESSMENT = 'earlyPhaseAssessment',
}

export enum ChatType {
  EVALUATION,
  RFP,
  BID,
  CONTRACT,
  SUPPLEMENT,
  EARLY_PHASE_ASSESSMENT,
}

export enum SummarizationTopicStatus {
  FAILED = -20,
  NOT_FOUND = 15,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  DONE = 20,
}

export enum ReportExportStatus {
  NOT_STARTED = 10,
  IN_PROGRESS = 20,
  SUCCESS = 30,
  FAILED = 40,
}

export enum InconsistencyTypes {
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
  EARLY_PHASE_ASSESSMENT = 'earlyPhaseAssessment',
}

export enum InconsistencyStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export enum InconsistencyStatementType {
  LOW = 0,
  MEDIUM = 1,
  SEVERE = 2,
}

export enum AmbiguityTypes {
  TENDER_PACKAGE = 'tenderPackage',
  CONTRACT = 'contract',
  BID = 'bid',
}

export enum AmbiguityStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export enum BidDraftingStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  DONE = 20,
}

export enum StrengthsAndWeaknessesStatusEnum {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export enum SeverityEnum {
  LOW = 25,
  MEDIUM = 50,
  SEVERE = 75,
}

export enum WorkPackageStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  PARTIAL = 'partial',
  FAILED = 'failed',
}

export enum WorkPackageColumnType {
  SUMMARY = 'summary',
  SUMMARY_DETAILED = 'summary_detailed',
  CHECKLIST = 'checklist',
}

export enum BidComparisonColumnStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  DONE = 20,
  FAILED = -20,
}
export type AnalysisStatus =
  | DeviationsStatus
  | InconsistencyStatus
  | AmbiguityStatus
  | BidQualityStatus
  | BidDraftingStatus
  | CvAssessmentStatus
  | EarlyPhaseAssessmentDependencyStatus
  | TenderFeedbackPositivesNegativesStatus
  | ContractClauseScannerAnalysisStatus;

export enum ChatRole {
  SYSTEM = 10,
  ASSISTANT = 20,
  USER = 30,
}

export enum AnswerType {
  SHORT = 10,
  REGULAR = 0,
}

export enum FileExtensions {
  UNKNOWN = 'UNKNOWN',
  PDF = 'PDF',
  DOCX = 'DOCX',
  XLSX = 'XLSX',
  CSV = 'CSV',
}

export type OrderDirection = 'asc' | 'desc';

export enum UserRole {
  USER = 'organization_member',
  ORGANIZATION_ADMIN = 'organization_admin',
  SYSTEM_ADMIN = 'system_admin',
}

export const REFETCH_SUMMARIZATION_INTERVAL = 8;
export const REFETCH_DOCUMENTS_ENTITY_INTERVAL = 8;

export const ProjectPhaseValuesEnum = {
  EarlyStageAndPreconstruction: 10,
  Execution: 20,
  Operations: 30,
} as const;

export type ProjectPhaseLabels = keyof typeof ProjectPhaseValuesEnum;

export const TenderPackageAndContractsPhaseValuesEnum = {
  EarlyStageAndPreconstruction: 10,
  ExecutionDeveloperGeneralContractor: 23,
  ExecutionSubcontractorOrSupplier: 26,
  Operations: 30,
} as const;

export type TenderPackageAndContractsPhaseLabels =
  keyof typeof TenderPackageAndContractsPhaseValuesEnum;

export const OtherDocumentsPhaseValuesEnum = {
  EarlyStageAndPreconstruction: 10,
  Execution: 20,
  Operations: 30,
} as const;

export type OtherDocumentsPhaseLabels = keyof typeof OtherDocumentsPhaseValuesEnum;

export const EarlyPhaseAssessmentPhaseValuesEnum = {
  EarlyStageAndPreconstruction: 10,
  Execution: 20,
  ExecutionDeveloperGeneralContractor: 23,
  ExecutionSubcontractorOrSupplier: 26,
  Operations: 30,
} as const;

export type EarlyPhaseAssessmentPhaseLabels = keyof typeof EarlyPhaseAssessmentPhaseValuesEnum;

export enum LearningStatementTypeEnum {
  Gaps = 'COMMON_MISTAKES',
  Strengths = 'COMMON_STRENGTHS',
}

export enum ProjectTypeLabelsEnum {
  Building = 'Building',
  Infrastructure = 'Infrastructure',
  None = 'None',
}

export const ProjectTypeEnum = {
  Building: 'BUILDING',
  Infrastructure: 'INFRASTRUCTURE',
} as const;

export enum OrgTenderFeedbacksProjectTypeEnum {
  Building = 'BUILDING',
  Infrastructure = 'INFRASTRUCTURE',
}

export enum EvaluationTypeEnum {
  TenderPackage = 10,
  Contract = 20,
}

export enum ProxyEvaluationTypeEnum {
  tenderPackage = 10,
  bid = 20,
  contract = 30,
  contractSupplementPackages = 50,
  tenderFeedback = 60,
  internalKnowledgeBase = 70,
  earlyPhaseAssessment = 80,
}

export enum EvaluationTypeLabelsEnum {
  TENDER_PACKAGE = 'TenderPackage',
  CONTRACT = 'Contract',
  EARLY_PHASE_ASSESSMENT = 'EarlyPhaseAssessment',
}

export enum EvaluationCreatorTypeLabelsEnum {
  CLIENT = 'client',
  SUPPLIER = 'supplier',
}

export enum TopicGenerationStatus {
  FAILED = 'Failed',
  NOT_STARTED = 'NotStarted',
  IN_PROGRESS = 'InProgress',
  NOT_FOUND = 'NotFound',
  DONE = 'Done',
}

export const dateFormats = {
  withTime: 'd.MM.yyyy hh:mm',
  dayFirst: 'd.MM.yyyy',
  yearFirst: 'yyyy-MM-dd',
  localizedLong: 'PPP',
  dayFullMonthYear: 'd MMMM yyyy',
  dayAndMonth: 'd MMM',
  dayMonthWithTime: 'd MMM, hh:mm',
} as const;

export enum ProjectUserRoles {
  ADMIN = 'project_admin',
  MEMBER = 'project_member',
}

export enum OrganisationUserRoles {
  ADMIN = 'organization_admin',
  MEMBER = 'organization_member',
}

export enum UserInvitationStatus {
  PENDING = 0,
  ACCEPTED = 10,
  CANCELLED = -10,
}

export enum ProjectModeEnum {
  OPEN = 10,
  RESTRICTED = 20,
}

export enum ExtractionTemplateOwnershipEnum {
  VOLVE = 10,
  YOU = 20,
  ORGANIZATION = 30,
}

export enum BidQualityStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export const AssessmentLabels = {
  perfect: 'perfect',
  excellent: 'excellent',
  veryGood: 'veryGood',
  good: 'good',
  decent: 'decent',
  mediocre: 'mediocre',
  fair: 'fair',
  weak: 'weak',
  veryWeak: 'veryWeak',
  terrible: 'terrible',
  critical: 'critical',
} as const;

export enum GenericEvent {
  BUTTON_CLICKED = 'BUTTON_CLICKED',
  NAV_CLICKED = 'NAV_CLICKED',
  MODAL_OPENED = 'MODAL_OPENED',
}

export enum SpecificEvent {
  // Onboarding
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',

  // QA
  QA_USED = 'QA_USED',

  // Evaluations
  EVALUATION_CREATED = 'EVALUATION_CREATED',
  EVALUATION_UPDATED = 'EVALUATION_UPDATED',

  // Extractions
  EXTRACTIONS_TEMPLATE_CREATED = 'EXTRACTIONS_TEMPLATE_CREATED',
  EXTRACTIONS_TEMPLATE_COPIED = 'EXTRACTIONS_TEMPLATE_COPIED',
  EXTRACTION_CREATED = 'EXTRACTION_CREATED',
  EXTRACTION_UPDATED = 'EXTRACTION_UPDATED',

  // Documents
  DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
  DOCUMENT_DELETED = 'DOCUMENT_DELETED',
  DOCUMENT_REPLACED = 'DOCUMENT_REPLACED',

  // Analysis
  ANALYSIS_TRIGGERED = 'ANALYSIS_TRIGGERED',

  // Feedback
  POSITIVE_FEEDBACK_SENT = 'POSITIVE_FEEDBACK_SENT',
  NEGATIVE_FEEDBACK_SENT = 'NEGATIVE_FEEDBACK_SENT',

  // Projects
  PROJECT_PINNED = 'PROJECT_PINNED',
  PROJECT_UNPINNED = 'PROJECT_UNPINNED',
  PROJECT_SOFT_ARCHIVED = 'PROJECT_SOFT_ARCHIVED',
  PROJECT_SOFT_ARCHIVED_RESTORE = 'PROJECT_SOFT_ARCHIVED_RESTORE',

  // Change Assessments
  CHANGE_ASSESSMENT_ADDED = 'CHANGE_ASSESSMENT_ADDED',

  // Sharepoint
  SHAREPOINT_FILES_IMPORTED = 'SHAREPOINT_FILES_IMPORTED',

  // Insights
  INSIGHT_SAVED = 'INSIGHT_SAVED',

  // Internal Knowledge Base
  KNOWLEDGE_BASE_STANDARD_UPLOADED = 'KNOWLEDGE_BASE_STANDARD_UPLOADED',

  // Work Packages
  WP_COLUMN_ADDED = 'WP_COLUMN_ADDED',
  WP_SHEET_CREATED = 'WP_SHEET_CREATED',
  WP_PACK_SELECTED = 'WP_PACK_SELECTED',
  WP_COLUMN_HIDDEN = 'WP_COLUMN_HIDDEN',
  WP_COLUMN_SHOWN = 'WP_COLUMN_SHOWN',
  WP_SUMMARY_MODAL_OPENED = 'WP_SUMMARY_MODAL_OPENED',
  WP_REQUIREMENT_MODAL_OPENED = 'WP_REQUIREMENT_MODAL_OPENED',
  WP_CHECKLIST_MODAL_OPENED = 'WP_CHECKLIST_MODAL_OPENED',
  WP_CELL_CONTENT_EXPANDED = 'WP_CELL_CONTENT_EXPANDED',
  WP_CELL_CONTENT_COLLAPSED = 'WP_CELL_CONTENT_COLLAPSED',
  WP_CHECKLIST_ADDED = 'WP_CHECKLIST_ADDED',
  WP_CHECKLIST_TEMPLATE_CREATED = 'WP_CHECKLIST_TEMPLATE_CREATED',
  WP_CHECKLIST_TEMPLATE_MODIFIED = 'WP_CHECKLIST_TEMPLATE_MODIFIED',
  WP_CHECKLIST_TEMPLATE_DELETED = 'WP_CHECKLIST_TEMPLATE_DELETED',
}

export enum FeedbackStatementTypeEnum {
  StaticTopicStatement = 10,
  CustomTopicStatement = 20,
  DeviationStatement = 30,
  AmbiguityStatement = 40,
  InconsistencyStatement = 50,
  BidQualityStatement = 60,
  ChatMessage = 70,
  StrengthsWeaknesses = 80,
  BidCVAssessmentStatement = 90,
  Dependency = 100,
  Topic = 110,
}

export enum CvAssessmentStatementType {
  STRENGTH = 1,
  RISK = 2,
  SUGGESTION = 3,
}

export enum CvAssessmentStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  COMPLETED = 20,
  FAILED = 30,
  RFP_NOT_EXHAUSTIVE = 40,
  BID_NOT_EXHAUSTIVE = 50,
}

export enum EarlyPhaseAssessmentInconsistencyStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export enum EarlyPhaseAssessmentDependencyStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
}

export enum EarlyPhaseDependencyRiskEnum {
  LOW = 0,
  MEDIUM = 1,
  HIGH = 2,
}

export enum EarlyPhaseTriggerEventEnum {
  PriorToConstructionPermit = 10,
  PriorToOccupancyPermit = 20,
  PriorToPlanningApproval = 30,
  AtCertificateOfCompletion = 40,
}

export enum EarlyPhaseDependencyLocationEnum {
  ON_SITE = 0,
  OFF_SITE = 1,
  UNCLEAR = 2,
}

export enum EarlyPhaseDependencyResponsiblePartyEnum {
  DEVELOPER = 0,
  MUNICIPALITY = 1,
  UTILITY = 2,
  NEIGHBOUR = 3,
  GOVERNMENT = 4,
  UNKNOWN = 5,
}

export enum DocumentTypeEnum {
  RFP = 10,
  BID = 20,
  CONTRACT = 30,
  KNOWLEDGE_BASE_DOCUMENT = 50,
  CONTRACT_SUPPLEMENT = 60,
  TENDER_FEEDBACK = 70,
  EARLY_PHASE_ASSESSMENT = 80,
}

export const DEPENDENCIES_SETUP_CANVAS_PADDING = 200;

export const DEPENDENCIES_DOT_SIZES = {
  outerRadiusActive: 17,
  outerRadiusInactive: 14,
  innerRadius: 11,
  strokeWidth: 4,
};
export const DEPENDENCIES_LINE_WIDTH = 5;

export enum TenderFeedbackPositivesNegativesStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  DONE = 20,
  FAILED = -20,
}

export enum PositiveNegativeFeedbackType {
  POSITIVE = 0,
  NEGATIVE = 1,
}

export enum ContractSupplementPackageDocFilters {
  MEETING_MINUTES = 'MeetingMinutes',
  INVOICES = 'Invoices',
  CHANGE_ORDERS = 'ChangeOrders',
  OTHER_DOCUMENTS = 'OtherDocuments',
  ALL = 'All',
}

export enum SupplementPackageDocLabels {
  MINUTES_OF_MEETING = 'MINUTES_OF_MEETING',
  INVOICES = 'INVOICES',
  CHANGE_ORDERS = 'CHANGE_ORDERS',
  OTHER = 'OTHER',
}

export enum ChangeAssessmentStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  NOT_FOUND = 15,
  COMPLETED = 20,
  FAILED = -20,
}

export enum SupplementOverviewStatus {
  IN_PROGRESS = 'InProgress',
  DONE = 'Done',
  FAILED = 'Failed',
}

export enum ChangeAssessmentVerdict {
  Entitled = 'Entitled',
  PartiallyEntitled = 'PartiallyEntitled',
  NotEntitled = 'NotEntitled',
  NeedsClarification = 'NeedsClarification',
}

export enum ChatDocumentTypesEnum {
  MINUTES_OF_MEETING = 'MINUTES_OF_MEETING',
  CHANGE_ORDERS = 'CHANGE_ORDERS',
  INVOICE = 'INVOICE',
  OTHER = 'OTHER',
}

export const documentTypesOptions = Object.entries(ChatDocumentTypesEnum).map(([label, value]) => ({
  label,
  value,
}));

export enum ContractClauseScannerAnalysisStatus {
  IN_PROGRESS = 'InProgress',
  DONE = 'Done',
  FAILED = 'Failed',
}

export enum ClauseScannerAnalysisType {
  TENDER_PACKAGE = 'TenderPackage',
  CONTRACT = 'Contract',
}

export enum UserReview {
  CHECKED = 'CHECKED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  IGNORED = 'IGNORED',
  NONE = 'NONE',
}

export enum StandardDeviationStatementType {
  CONFLICT = 'conflict',
  LOOSER = 'looser',
  STRICTER = 'stricter',
  ADDITIONAL_OBLIGATION = 'additional_obligation',
  PROCEDURAL_CHANGE = 'procedural_change',
}

export enum ClauseScannerClauseAttentionLevel {
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  APPEARS_STANDARD = 'APPEARS_STANDARD',
  INCONCLUSIVE = 'INCONCLUSIVE',
}

export enum ClauseScannerSubcategoryClauseInFavorOf {
  SUPPLIER = 'SUPPLIER',
  CLIENT = 'CLIENT',
  NEUTRAL = 'NEUTRAL',
}

export enum ClauseScannerSubcategoryClauseClientRiskStrategy {
  TRANSFER = 'TRANSFER',
  SHARING = 'SHARING',
  LIMITATION = 'LIMITATION',
  ACCEPTANCE = 'ACCEPTANCE',
}

export enum SharePointItemTypeEnum {
  FILE = 'file',
  FOLDER = 'folder',
}

export const docTypeToEvalType: Record<DocumentTypes, ProxyEvaluationTypeEnum> = {
  [DocumentTypes.BID]: ProxyEvaluationTypeEnum.bid,
  [DocumentTypes.TENDER_PACKAGE]: ProxyEvaluationTypeEnum.tenderPackage,
  [DocumentTypes.CONTRACT]: ProxyEvaluationTypeEnum.contract,
  [DocumentTypes.SUPPLEMENT]: ProxyEvaluationTypeEnum.contractSupplementPackages,
  [DocumentTypes.EARLY_PHASE_ASSESSMENT]: ProxyEvaluationTypeEnum.earlyPhaseAssessment,
};

export enum GetExtractionsV2Target {
  EXTRACTIONS = 'Extractions',
  OVERVIEW = 'Overview',
}

export enum ExtractionFormat {
  SHORT = 'ShortConcise',
  MEDIUM = 'Medium',
}
